import { createActions, createReducer } from 'reduxsauce'

export interface IApp {
  titlePage: string | null
}
const { Types, Creators } = createActions({
  titlePage: ['titlePage']
})

export const AuthenticateTypes = Types

export default Creators

const INITIAL_STATE = {
  titlePage: null
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.TITLE_PAGE]: (state, { titlePage }) => ({ ...state, titlePage })
})
